import makeStyles from "@mui/styles/makeStyles";
import { Theme } from "@mui/material/styles";

type StyleProps = {
  isExpiredOrInvalidOrRejected: boolean;
};

const styles = makeStyles((theme: Theme) => ({
  invitationDescription: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: (props: StyleProps) => {
      return props.isExpiredOrInvalidOrRejected ? "1rem" : "0.875rem";
    },
    color: "#465869",
    "& > span": {
      fontWeight: 700,
    },
  },

  invitationDescriptionDeclined: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: "0.875rem",
    color: "#465869",
    marginTop: "1rem !important",
    "& > a": {
      textDecoration: "underline",
    },
  },

  invitationDescriptionExpired: {
    fontFamily: "Manrope",
    fontWeight: 500,
    fontSize: "0.875rem",
    color: "#465869",
    "& > a": {
      textDecoration: "underline",
    },
  },

  actionButton: {
    padding: "0.625rem 1.25rem",
  },

  loadingRequestNewInviteModal: {
    width: "16vw",
    [theme.breakpoints.down("md")]: {
      width: "30vw",
    },
    [theme.breakpoints.down("sm")]: {
      width: "50vw",
    },
    [theme.breakpoints.down("xs")]: {
      width: "70vw",
    },

    "& div > div:nth-child(1)": {
      display: "none",
    },

    "& div > div:nth-child(2)": {
      margin: 0,
      padding: "2.5rem",
    },
  },

  loadingRequestNewInviteModalContent: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    flexDirection: "column",
    gap: "2.25rem",

    "& h1": {
      color: "#308CDB !important",
      fontSize: "1.25rem",
      whiteSpace: "nowrap",
    },
  },

  loadingScreen: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "1.5rem",
    justifyContent: "center",
    height: "80%",
    alignItems: "center",
  },

  loadingScreenLabel: {
    fontFamily: "Manrope",
    fontSize: "1rem",
    color: "#9CA6AF",
  },
}));

export default styles;
